/*
 *
 * MissingShiftLeadersCard
 *
 */

import moment from 'moment';
import List from '@mui/material/List';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ShiftLeaderIcon from '@mui/icons-material/AccountCircle';
import { FormattedMessage } from 'react-intl';
import ScrollablePaper from '~/components/ScrollablePaper';
import ListItemButton from '@mui/material/ListItemButton';
import messages from './messages';
import { Link } from '@tanstack/react-router';

export const createApplicationInfoString = (application: {
  startDate: string;
  endDate: string;
}) => {
  const { startDate, endDate } = application;
  const dateString = moment(startDate).format('ddd L');
  const fromTime = moment(startDate).format('LT');
  const toTime = moment(endDate).format('LT');
  return `${dateString}, ${fromTime} - ${toTime}`;
};

type MissingShiftLeadersCardProps = {
  missingShiftleaders: Array<{
    id: number;
    startDate: string;
    endDate: string;
  }>;
};

export const MissingShiftLeadersCard = (
  props: MissingShiftLeadersCardProps
) => {
  const getLinkToAssignment = (assignment: {
    id: number;
    startDate: string;
  }) => {
    const shiftDate = moment(assignment.startDate);
    return `/application/${shiftDate.isoWeekYear()}/${shiftDate.isoWeek()}/${shiftDate.weekday()}/${
      assignment.id
    }`;
  };

  return (
    <div data-test="upcoming-assignments-card">
      <ScrollablePaper
        title={
          <FormattedMessage
            {...messages.missingShiftleaders}
            values={{ amount: props.missingShiftleaders.length }}
          />
        }
        isExpandable
        isClosedPerDefault={false}
        isLoading={false}
      >
        <List style={{ padding: 0 }}>
          {props.missingShiftleaders.map((assignment) => (
            <ListItemButton
              key={`missing-team-leader-${assignment.id}`}
              component={Link}
              to={getLinkToAssignment(assignment)}
            >
              <ListItemIcon>
                <ShiftLeaderIcon />
              </ListItemIcon>
              <ListItemText
                primary={createApplicationInfoString(assignment)}
                secondary={<FormattedMessage {...messages.noShiftLeaderYet} />}
              />
            </ListItemButton>
          ))}
        </List>
      </ScrollablePaper>
    </div>
  );
};

export default MissingShiftLeadersCard;
